<template>
  <!-- G6: "Create follow-up" from a task or event, at any time and as often as wanted -->
  <Dialog :visible.sync="shown" header="Create follow-up" :modal="true" :style="{ width: '760px' }" class="p-fluid" id="followUpDialog">
    <!-- the body scrolls, so the buttons stay on screen on a short window -->
    <div class="follow-up-scroll" style="max-height: 60vh; overflow-y: auto; overflow-x: hidden">
      <FollowUpFields v-if="form" :form="form" :types="types" :users="users" :problem="problem" />
    </div>
    <template #footer>
      <Button label="Cancel" icon="pi pi-times" class="p-button-text" @click="$emit('close')" />
      <Button id="saveFollowUp" label="Create follow-up" icon="pi pi-check" class="p-button-success" :disabled="saving" @click="save" />
    </template>
  </Dialog>
</template>

<script>
import ActivityService from '@/service/ActivityService'
import UserService from '@/service/UserService'
import FollowUpFields from './FollowUpFields'
import { newFollowUp, followUpProblem, followUpBody } from '@/mbp/activityFollowUp'

export default {
  name: 'FollowUpDialog',
  components: { FollowUpFields },
  props: {
    visible: { type: Boolean, required: true },
    source: { type: Object, required: true }
  },
  data: () => ({ form: null, types: [], users: [], problem: null, saving: false }),
  computed: {
    shown: {
      get () { return this.visible },
      set (v) { if (!v) this.$emit('close') }
    }
  },
  created () {
    this.form = newFollowUp(this.source, this.$store.getters['auth/getMyProfile'])
    new ActivityService().getAllActivityTypes().then(data => { this.types = data || [] }).catch(() => {})
    new UserService().getAllActiveUsers().then(data => { this.users = data || [] }).catch(() => {})
  },
  methods: {
    save () {
      this.problem = followUpProblem(this.form)
      if (this.problem) return Promise.resolve()
      this.saving = true
      return new ActivityService()
        .createFollowUp(this.source.activityId, followUpBody(this.form))
        .then(id => {
          this.$toast.add({ severity: 'success', summary: 'Follow-up created', detail: this.form.subject, life: 4000 })
          this.$emit('saved', id)
        })
        .catch(err => {
          this.problem = (err && err.response && typeof err.response.data === 'string' && err.response.data) ||
            'The follow-up was not created.'
        })
        .finally(() => { this.saving = false })
    }
  }
}
</script>
